/**
 * Tema claro/escuro. Um lugar só para aplicar e GRAVAR a escolha: o botão da barra superior
 * trocava as classes sem gravar, e no login seguinte o portal voltava ao padrão (escuro).
 *
 * Padrão do portal: escuro. Só fica claro quando o usuário escolhe — e a escolha fica no
 * navegador (localStorage, chave "theme"), sobrevivendo a sair e entrar de novo.
 */
const CHAVE = "theme";

export const temaEscuroAtivo = () => typeof document !== "undefined" && document.body.classList.contains("dark");

export const temaEscuroGravado = () => {
  try {
    return localStorage.getItem(CHAVE) !== "light";
  } catch {
    return true;
  }
};

/** Aplica no `body` (Tailwind `dark` + tema nativo do RSuite) e grava a preferência. */
export const aplicarTema = (escuro: boolean, gravar = true) => {
  document.body.classList.toggle("dark", escuro);
  document.body.classList.toggle("rs-theme-dark", escuro);
  if (!gravar) return;
  try {
    localStorage.setItem(CHAVE, escuro ? "dark" : "light");
  } catch {
    /* sem storage (janela privada): vale só nesta sessão */
  }
};
